export default "__VITE_ASSET__DMFPZRdq__"